(function () {
  var aosInitialized = false;
  var sectionSelector = '#MainContent > .shopify-section, #MainContent > .section-wrapper';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function applyAutomaticSectionAnimation(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll(sectionSelector));

    if (root && root.matches && root.matches(sectionSelector)) {
      sections.unshift(root);
    }

    sections.forEach(function (section) {
      if (section.hasAttribute('data-aos')) return;

      section.setAttribute('data-aos', 'fade');
      section.setAttribute('data-aos-duration', '700');
      section.setAttribute('data-aos-once', 'true');
    });
  }

  function refreshAOS(root) {
    applyAutomaticSectionAnimation(root);

    if (!window.AOS) return;

    if (!aosInitialized) {
      window.AOS.init({
        duration: 700,
        easing: 'ease-out',
        offset: 80,
        once: true,
        disable: prefersReducedMotion,
      });
      aosInitialized = true;
      return;
    }

    window.AOS.refreshHard();
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  onReady(function () {
    refreshAOS(document);

    var mainContent = document.getElementById('MainContent');

    if (mainContent && 'MutationObserver' in window) {
      var refreshTimer = null;
      var observer = new MutationObserver(function (mutations) {
        var shouldRefresh = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            if (!(node instanceof Element)) return false;

            return node.matches('.shopify-section, .section-wrapper') || node.querySelector('.shopify-section, .section-wrapper');
          });
        });

        if (!shouldRefresh) return;

        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(function () {
          refreshAOS(document);
        }, 50);
      });

      observer.observe(mainContent, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', function (event) {
      refreshAOS(event.target);
    });

    document.addEventListener('shopify:section:select', function (event) {
      refreshAOS(event.target);
    });

    document.addEventListener('shopify:block:select', function () {
      refreshAOS(document);
    });
  });
})();
